
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TpParameters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Part"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicleSpecifications"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"model"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Model"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Manufacturer"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"modification"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modification"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"engine"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"vinCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bodyType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"driveType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gearType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"steeringType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuelType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fuelSystem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coolingType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engineDisplacement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mileage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mileageType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"platformType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axleConfiguration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frontSuspensionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rearSuspensionType"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":567}};
    doc.loc.source = {"body":"#import '@/models/Model/Schema.gql'\n#import '@/models/Manufacturer/Schema.gql'\n#import '@/models/Modification/Schema.gql'\n\nfragment TpParameters on Part {\n\tvehicleSpecifications {\n\t\tid\n\t\tmodel {\n\t\t\t...Model\n\t\t}\n\t\tmanufacturer {\n\t\t\t...Manufacturer\n\t\t}\n\t\tmodification {\n\t\t\t...Modification\n\t\t}\n\t\tengine {\n\t\t\tid\n\t\t\tname: title\n\t\t}\n\t\tvinCode\n\t\tcolor\n\t\tbodyType\n\t\tdriveType\n\t\tgearType\n\t\tsteeringType\n\t\tfuelType\n\t\tfuelSystem\n\t\tcoolingType\n\t\tengineDisplacement\n\t\tyear\n\t\tmileage\n\t\tmileageType\n\t\tplatformType\n\t\taxleConfiguration\n\t\tfrontSuspensionType\n\t\trearSuspensionType\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('@/models/Model/Schema.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/models/Manufacturer/Schema.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/models/Modification/Schema.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["TpParameters"] = oneQuery(doc, "TpParameters");
        
